"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshBalancesCoinsObservable = exports.useBalancesCoins = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const AssetAPILib_1 = require("../AssetAPI/AssetAPILib");
const trade_utils_lib_1 = require("trade_utils_lib");
const react_1 = require("react");
const FetchData = (params) => {
    return (0, trade_utils_lib_1.getTradeDependencyInstance)()
        .getUserId()
        .pipe((0, operators_1.mergeMap)((userId) => {
        const modelParam = {
            keyId: "common_data",
            dataKey: "get_v2_balances_coins" + (userId !== null && userId !== void 0 ? userId : "none"),
            expireTime: trade_utils_lib_1.EXPIRED_TYPE.NEVER,
            refresh: () => new AssetAPILib_1.AssetAPILib().getBalancesCoins(params.app_lang),
        };
        return (0, trade_utils_lib_1.getDataWithCache)(modelParam);
    }), (0, operators_1.catchError)((err) => {
        return rxjs_1.NEVER;
    }));
};
const triggerSubject = new rxjs_1.Subject();
const createPublisher = (params) => {
    return (0, rxjs_1.merge)((0, rxjs_1.timer)(0, 5000), triggerSubject).pipe((0, operators_1.switchMap)(() => {
        return FetchData(params);
    }), (0, operators_1.publishBehavior)(undefined), (0, operators_1.refCount)());
};
const publishers = new Map();
const getObservable = (params) => {
    const key = params.app_lang;
    const cachePub = publishers.get(key);
    let ob;
    if (cachePub) {
        ob = cachePub;
    }
    else {
        const pub = createPublisher(params);
        publishers.set(key, pub);
        ob = pub;
    }
    return ob.pipe((0, operators_1.map)((res) => {
        if (res) {
            return Object.assign(Object.assign({}, res), { app_lang: key });
        }
        return res;
    }));
};
const RefreshBalancesFull = () => {
    triggerSubject.next(new Date().getTime());
};
const useBalancesCoins = (app_lang, isActive = true) => {
    const [data, setData] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!isActive) {
            return;
        }
        const sub = getObservable({ app_lang: app_lang }).subscribe({
            next: (res) => {
                setData(res);
            },
            error: () => { }, // 不会遇到错误
        });
        return () => {
            sub.unsubscribe();
        };
    }, [app_lang, isActive]);
    return data;
};
exports.useBalancesCoins = useBalancesCoins;
const RefreshBalancesCoinsObservable = (app_lang) => {
    RefreshBalancesFull();
    return getObservable({ app_lang: app_lang }).pipe((0, operators_1.skip)(1), (0, operators_1.take)(1)); // 第一次为缓存
};
exports.RefreshBalancesCoinsObservable = RefreshBalancesCoinsObservable;
